import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from '@shared/services/api.service'
import { map } from 'rxjs/operators'
import { SearchResult, SearchResultGroup, SearchResultType } from './search/search-result.model'
import { User } from '@shared/models/user.model'
import { Device } from '@shared/models/device.model'
import { Client } from '@shared/models/client.model'
import { Vehicle } from '@shared/models/vehicle.model'
import { Geofence } from '@app/modules/client/shared/models/geofence.model'
@Injectable({ providedIn: 'root' })
export class ToolbarService {
  constructor(private apiService: ApiService) {}

  search(query: string): Observable<SearchResult> {
    const mapTypeToClass = {
      [SearchResultType.User]: User,
      [SearchResultType.Client]: Client,
      [SearchResultType.Device]: Device,
      [SearchResultType.Vehicle]: Vehicle,
      [SearchResultType.Geofence]: Geofence,
    }

    const toInstances = (group: SearchResultGroup) => {
      const instanceClass = mapTypeToClass[group.type]
      if (instanceClass) {
        group.items = (group.items as any).map((item) => new instanceClass(item)) as any
      }

      return group
    }

    return this.apiService.get('/search', { params: { query } }).pipe(
      map((response) => response['data']),
      map((result: SearchResult) => result.map(toInstances)),
    )
  }
}
